export enum RoleNames {
  COMPANY = 1,
  USER = 2,
}
